<template>
  <div class="collections">
    <Nav activeNav="collections"></Nav>

    <div class="container">
      <div class="sider">
        <div class="label">历届作品</div>

        <el-input
          placeholder=""
          size="small"
          v-model="keyword"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="toSearch"
          ></el-button>
        </el-input>

        <el-collapse v-model="activeNames">
          <el-collapse-item title="年份" name="年份">
            <ul class="options">
              <li
                :class="[
                  'option',
                  {
                    'option-active': year === item.value
                  }
                ]"
                v-for="item in yearOptions"
                :key="item.value"
                @click="year = item.value"
              >
                {{ item.label }}
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="类别" name="类别">
            <ul class="options">
              <li
                :class="[
                  'option',
                  {
                    'option-active': type === item.value
                  }
                ]"
                v-for="item in typeOptions"
                :key="item.value"
                @click="type = item.value"
              >
                {{ item.label }}
              </li>
            </ul>
          </el-collapse-item>
          <el-collapse-item title="奖项" name="奖项">
            <ul class="options">
              <li
                :class="[
                  'option',
                  {
                    'option-active': awardLabel === item.value
                  }
                ]"
                v-for="item in awardLabelOptions"
                :key="item.value"
                @click="awardLabel = item.value"
              >
                {{ item.label }}
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="main">
        <!-- <div class="top-title">作品列表</div> -->

        <div class="label">全部</div>

        <ul v-loading="loading" class="list" v-if="list.length">
          <li
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="toDetail(item)"
          >
            <div class="show">
              <img
                class="img"
                :src="item.thumbnailUrl"
                :alt="item.thumbnailUrl"
              />
            </div>
            <div class="content">
              <h3 class="title">
                {{ item.title }}
              </h3>
              <p class="teamName">{{ item.teamName }}</p>
              <p class="institution">{{ item.institution }}</p>
            </div>
            <img
              v-if="item.awardLabel === '金奖'"
              class="img-label"
              src="@/assets/images/jinjiang.png"
              alt="yinjiang"
            />
            <img
              v-if="item.awardLabel === '银奖'"
              class="img-label"
              src="@/assets/images/yinjiang.png"
              alt="yinjiang"
            />
            <img
              v-if="item.awardLabel === '铜奖'"
              class="img-label"
              src="@/assets/images/tongjiang.png"
              alt="yinjiang"
            />
            <img
              v-if="
                item.awardLabel === '优秀奖' || item.awardLabel === '优胜奖'
              "
              class="img-label"
              src="@/assets/images/youshengjiang.png"
              alt="yinjiang"
            />
          </li>
        </ul>
        <el-empty v-else description="暂无数据"></el-empty>

        <el-pagination
          background
          class="pagination"
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <div class="detail" v-if="item">
        <div class="detail-top">
          <h3 class="detail-title">
            {{ item.title }}
          </h3>
          <div class="detail-label">
            <span
              v-if="item.awardLabel === '金奖'"
              class="label-item label-item-jinjiang"
            >
              {{ item.awardLabel }}
            </span>
            <span
              v-if="item.awardLabel === '银奖'"
              class="label-item label-item-yinjinag"
            >
              {{ item.awardLabel }}
            </span>
            <span
              v-if="item.awardLabel === '铜奖'"
              class="label-item label-item-tongjiang"
            >
              {{ item.awardLabel }}
            </span>
            <span
              v-if="
                item.awardLabel === '优秀奖' || item.awardLabel === '优胜奖'
              "
              class="label-item label-item-yousheng"
            >
              {{ item.awardLabel }}
            </span>
            <span class="label-item">{{ item.year }}</span>
            <span class="label-item">
              {{ item.type == 1 ? '产品类' : '创意类' }}
            </span>
          </div>
        </div>
        <p class="detail-record">设计团队: {{ item.teamName }}</p>
        <p class="detail-record">院校单位: {{ item.institution }}</p>
        <p class="detail-record">设计说明: {{ item.designNotes }}</p>
        <img
          class="detail-thumbnailUrl"
          :src="item.thumbnailUrl"
          :alt="item.thumbnailUrl"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Nav from '../event/coms/nav'

export default {
  components: {
    Nav
  },
  data() {
    return {
      keyword: '',
      activeNames: ['年份', '类别', '奖项'],
      yearOptions: [
        {
          label: 'ALL',
          value: 'ALL'
        },
        {
          label: '2024',
          value: '2024'
        },
        {
          label: '2023',
          value: '2023'
        },
        {
          label: '2022',
          value: '2022'
        },
        {
          label: '2021',
          value: '2021'
        },
        {
          label: '2019',
          value: '2019'
        },
        {
          label: '2018',
          value: '2018'
        }
      ],
      typeOptions: [
        {
          label: 'ALL',
          value: 'ALL'
        },
        {
          label: '产品类',
          value: '1'
        },
        {
          label: '创意类',
          value: '2'
        }
      ],
      awardLabelOptions: [
        {
          label: 'ALL',
          value: 'ALL'
        },
        {
          label: '金奖',
          value: '金奖'
        },
        {
          label: '银奖',
          value: '银奖'
        },
        {
          label: '铜奖',
          value: '铜奖'
        },
        {
          label: '优胜奖',
          value: '优胜奖'
        }
      ],
      year: 'ALL',
      type: 'ALL',
      awardLabel: 'ALL',
      dialogVisible: false,
      eventList: [],
      eventTotal: 0,
      eventCurrent: 1,
      eventPageSize: 10,
      loading: true,
      jsId: this.$route.params.jsId,
      detail: null,
      list: [],
      pageSize: 5,
      current: 1,
      total: 0,
      item: null
    }
  },
  computed: {
    query() {
      return {
        year: this.year,
        type: this.type,
        awardLabel: this.awardLabel
      }
    }
  },
  watch: {
    query() {
      this.jsHistoricalWork()
    }
  },
  async mounted() {
    if (!this.jsId) {
      this.jsId = await this.fetchJsRecordList()
    }
    this.jsHistoricalWork()
  },
  methods: {
    toSearch() {
      this.jsHistoricalWork()
    },
    async fetchJsRecordList(pageIndex = 1) {
      const [err, res] = await this.$serve.jsRecord.getPageList({
        data: { pageIndex }
      })
      if (err) return
      this.eventList = res.records
      this.eventTotal = res.total
      this.eventCurrent = res.pageIndex
      this.eventPageSize = res.pageSize
      return this.eventList[0].id
    },
    async jsHistoricalWork(pageIndex = 1) {
      this.loading = true
      const [err, res] = await this.$serve.jsHistoricalWork.getPageList({
        data: {
          pageIndex,
          pageSize: 12,
          jsId: this.jsId,
          year: this.year === 'ALL' ? '' : this.year,
          type: this.type === 'ALL' ? '' : this.type,
          awardLabel: this.awardLabel === 'ALL' ? '' : this.awardLabel,
          keyword: this.keyword
        }
      })
      this.loading = false
      if (err) return
      this.list = res.records
      this.pageSize = res.pageSize
      this.current = res.pageIndex
      this.total = res.total
    },
    currentChange(pageIndex) {
      this.jsHistoricalWork(pageIndex)
    },
    toDetail(item) {
      this.item = item
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.collections {
  padding-bottom: 40px;

  .container {
    max-width: 1320px;
    margin: 0 auto;
    padding: 40px 0 20px 0;
    display: flex;
    gap: 30px;
  }

  .sider {
    width: 200px;
    // padding: 66.8px 0 0;
    flex-shrink: 0;
  }

  .option {
    cursor: pointer;
  }

  .option + .option {
    margin-top: 10px;
  }

  .option-active {
    color: rgb(209, 183, 104);
  }

  .main {
    flex: 1;
  }

  .top-title {
    text-align: center;
    color: rgb(209, 183, 104);
    font-weight: 600;
    font-size: 32px;
    margin-bottom: 30px;
  }

  .label {
    border-bottom: 1px solid #000;
    margin-bottom: 40px;
    padding-bottom: 30px;
    font-size: 24px;
  }

  .list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
    gap: 20px;
  }

  .item {
    cursor: pointer;
    border: 2px solid #b6b6b6;
    overflow: hidden;
    position: relative;
  }

  .show {
    width: 100%;
    padding-top: 120%;
    position: relative;
    overflow: hidden;
  }

  .img {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #f5f5f5;
  }

  .img-label {
    position: absolute;
    right: -2px;
    top: -2px;
  }

  .content {
    padding: 10px;
    line-height: 1.5;
  }

  .title {
    margin: 4px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .teamName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #999;
  }

  .institution {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #999;
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
  }

  .detail-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
  }

  .detail-label {
    display: flex;
    gap: 10px;
  }

  .label-item {
    border: 1px solid #000;
    padding: 4px 8px;
  }

  .label-item-jinjiang {
    background: rgb(168, 147, 83);
    color: #fff;
    border-color: rgb(168, 147, 83);
  }

  .label-item-yinjinag {
    background: #838280;
    color: #fff;
    border-color: #838280;
  }

  .label-item-tongjiang {
    background: #856038;
    color: #fff;
    border-color: #856038;
  }

  .label-item-yousheng {
    background: #000;
    color: #fff;
    border-color: #000;
  }

  .detail-record {
    color: #888;
    line-height: 1.5;
    margin-bottom: 4px;
  }

  .detail-thumbnailUrl {
    margin-top: 10px;
    width: 100%;
  }
}
</style>
